import { HabitEntity } from '../domain/habit';
import { HabitFilter } from '../domain/weakEntities/habitFilter';

export function filterHabits(habits: HabitEntity[], filter: HabitFilter) {
  const ids = new Set(filter);
  return habits.filter((habit) => ids.has(habit.id));
}
